module.exports = __webpack_public_path__ + "static/media/ilu5.365173f9.png";